import { render, staticRenderFns } from "./healthInform.vue?vue&type=template&id=e72129c8&scoped=true"
import script from "./healthInform.vue?vue&type=script&lang=js"
export * from "./healthInform.vue?vue&type=script&lang=js"
import style0 from "./healthInform.vue?vue&type=style&index=0&id=e72129c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72129c8",
  null
  
)

export default component.exports